<p class="page-title">現場情報登録 / 変更</p>
<mat-card class="config-site-sensor-card">
  <mat-card-header>
    <mat-card-title class="config-site-sensor-title">
      {{ site?.name }}　山留センサー{{ isUpdate ? "変更" : "登録" }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form
      class="form"
      [formGroup]="form"
      (keydown.enter)="$event.preventDefault()"
      autocomplete="off"
    >
      <mat-form-field>
        <mat-label>センサーID</mat-label>
        <mat-select
          formControlName="sensorId"
          required
          (selectionChange)="onSensorSelected($event.value)"
        >
          <mat-option [value]="undefined"> 未登録 </mat-option>
          <mat-option *ngFor="let sensor of sensors" [value]="sensor.id">
            {{ sensor.id }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>設置場所</mat-label>
        <input
          matInput
          name="positionName"
          formControlName="positionName"
          placeholder="設置場所"
          required
        />
      </mat-form-field>

      <div>
        <mat-form-field>
          <mat-label>掘削底面からの高さ</mat-label>
          <input
            matInput
            name="heightFromBottom"
            formControlName="heightFromBottom"
            placeholder="1000"
            required
          />
        </mat-form-field>
        (mm)
      </div>

      <div>
        <mat-form-field>
          <mat-label>管理基準値</mat-label>
          <input
            matInput
            name="managementStandard"
            formControlName="managementStandard"
            placeholder="5"
            required
          />
        </mat-form-field>
        (mm)
      </div>

      <div>
        <mat-form-field>
          <mat-label>1時間あたりの変位基準値</mat-label>
          <input
            matInput
            name="hourlyDisplacementStandard"
            formControlName="hourlyDisplacementStandard"
            placeholder="5"
            required
          />
        </mat-form-field>
        (mm)
      </div>

      <div>
        <button
          mat-raised-button
          color="primary"
          (click)="onZeroSet()"
          [disabled]="!selectedSensor"
        >
          ゼロセット
        </button>
      </div>

      <div class="latest-data-info">
        <div class="latest-data-date">
          最新データ受信日時:
          {{ (selectedSensor?.latestData?.date | date : "yyyy/MM/dd HH:mm:ss") || "-" }}
        </div>
        <div class="standard-date">
          登録済み基準値日時:
          {{ (selectedSensor?.standard?.date | date : "yyyy/MM/dd HH:mm:ss") || "-" }}
        </div>
      </div>

      <div>
        <mat-form-field>
          <mat-label> 基準値(X) </mat-label>
          <input
            matInput
            formControlName="standardX"
            placeholder="基準値(X)"
            readonly
          />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label> 基準値(Y) </mat-label>
          <input
            matInput
            formControlName="standardY"
            placeholder="基準値(Y)"
            readonly
          />
        </mat-form-field>
      </div>

    </form>
  </mat-card-content>

  <mat-card-actions align="end">
    <div>
      <button mat-raised-button color="accent" (click)="cancel()">
        キャンセル
      </button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="form.invalid"
        (click)="onSubmit()"
      >
        登録
      </button>
    </div>
  </mat-card-actions>

  <mat-card-footer>
    <mat-error *ngIf="0 < errors.length">
      <ul>
        <li *ngFor="let error of errors">{{ error }}</li>
      </ul>
    </mat-error>
  </mat-card-footer>
</mat-card>
